module Meevo.Plugins.MembershipDefinitions {
  "use strict";

  /**
  * Main Section of Employee 
  */
  export class MainSection extends Meevo.Components.BaseClasses.DataMaintenanceSectionBase<Model.Employee> {

  }

}